/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type TakeOverMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type TakeOverMutation = {
  __typename?: 'Mutation'
  fccStartHandlingVehicle: any | null
}

export const TakeOverDocument = gql`
    mutation TakeOver($vehicleId: ID!) {
  fccStartHandlingVehicle(vehicleId: $vehicleId)
}
    `
export type TakeOverMutationFn = Apollo.MutationFunction<
  TakeOverMutation,
  TakeOverMutationVariables
>

/**
 * __useTakeOverMutation__
 *
 * To run a mutation, you first call `useTakeOverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTakeOverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [takeOverMutation, { data, loading, error }] = useTakeOverMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useTakeOverMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TakeOverMutation,
    TakeOverMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<TakeOverMutation, TakeOverMutationVariables>(
    TakeOverDocument,
    options,
  )
}
export type TakeOverMutationHookResult = ReturnType<typeof useTakeOverMutation>
export type TakeOverMutationResult = Apollo.MutationResult<TakeOverMutation>
export type TakeOverMutationOptions = Apollo.BaseMutationOptions<
  TakeOverMutation,
  TakeOverMutationVariables
>
